import { useState } from 'react'

interface State {
  activeDialog: string | null
  data?: any
}

export default function useDialogHandler() {
  const [state, setState] = useState<State>({
    activeDialog: null,
    data: null,
  })

  return {
    ...state,
    openDialog: (dialog: string, data?: any) =>
      setState({
        activeDialog: dialog,
        data,
      }),
    closeDialog: () =>
      setState({
        activeDialog: null,
        data: null,
      }),
  }
}
